const formRows = [
  {
    span: 24,
    label: '公告标题',
    component: 'AInput',
    placeholder: '请输入公告标题',
    prop: 'title',
    allowClear: true
  },
  {
    span: 24,
    label: '运营类型',
    component: 'ARadioGroup',
    prop: 'operationType',
    radioList: [
      { label: '许可', value: '1' },
      { label: '待转化', value: '0' },
      { label: '质押', value: '2' },
      { label: '转让', value: '3' }
    ]
  },
  {
    span: 12,
    label: '许可方',
    component: 'AInput',
    placeholder: '请输入许可方',
    prop: 'licensor'
  },
  {
    span: 12,
    label: '被许可方',
    component: 'AInput',
    prop: 'licensee',
    placeholder: '请输入被许可方'
  },
  {
    span: 12,
    label: '价格',
    component: 'AInput',
    prop: 'price',
    placeholder: '请输入价格'
  },
  {
    span: 24,
    label: '交易附图',
    component: 'AUpload',
    prop: 'picPath'
  },
  {
    span: 24,
    label: '交易介绍',
    component: 'ATextArea',
    prop: 'content'
  }
]
var reg = new RegExp('^[1-9](\\d{0,7})((\\.\\d{1,2})?)$') // 校验数字
const formRules = {
  title: [{ required: true, message: '图形', trigger: 'blur' }],
  operationType: [
    { required: true, message: '运营类型不能为空', trigger: ['blur'] }
  ],
  licensor: [{ required: true, message: '许可方不能为空', trigger: ['blur'] }],
  licensee: [
    { required: true, message: '被许可方不能为空', trigger: ['blur'] }
  ],
  picPath: [{ required: true, message: '交易附图不能为空', trigger: ['blur'] }],
  content: [{ required: true, message: '交易介绍不能为空', trigger: ['blur'] }],
  price: [
    { required: true, message: '价格不能为空', trigger: ['blur'] },
    {
      validator: (rule, val, callback) => {
        if (!reg.test(val)) {
          callback(new Error('请输入最高8位整数,精确到小数点后两位'))
        } else {
          callback()
        }
      }
    }
  ]
}

const formInfo = [
  { label: '公告标题', value: '-', key: 'title' },
  { label: '运营类型', value: '-', key: 'operationTypeStr' },
  { label: '许可方', value: '-', key: 'licensor', isVHtml: true },
  { label: '被许可方', value: '-', key: 'licensee', isVHtml: true },
  { label: '价格', value: '-', key: 'price' },
  { label: '交易附图', value: '-', key: 'picture', isVHtml: true },
  { label: '交易介绍', value: '-', key: 'content' }
]

module.exports = {
  formRows,
  formRules,
  formInfo
}
